import qs from 'qs';
import { network } from 'services/network';

export const setSubProgramPreferenceProgressScurve = (params) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/setSubProgramPreferenceProgressScurve${querystring}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
